import CreditCardConnector from "./CreditCardConnector";

export default CreditCardConnector;
